import { render, staticRenderFns } from "./Sphere.vue?vue&type=template&id=f8ac909a&scoped=true&"
import script from "./Sphere.vue?vue&type=script&lang=js&"
export * from "./Sphere.vue?vue&type=script&lang=js&"
import style0 from "./Sphere.vue?vue&type=style&index=0&id=f8ac909a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ac909a",
  null
  
)

export default component.exports